import { render } from "./BabyIcon.vue?vue&type=template&id=1c96f8d3"
import script from "./BabyIcon.vue?vue&type=script&lang=js"
export * from "./BabyIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__